var map = {
	"./axj-information-within-school-api.js": "vcne"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QoBn";


//////////////////
// WEBPACK FOOTER
// ./src/api/axj-information -api.js$
// module id = QoBn
// module chunks = 1